import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppRoot } from './AppRoot';
import { FatalConfigScreen } from './components/FatalConfigScreen';
import { config } from './config';
import { ThemeModeProvider } from './theme/ThemeModeProvider';
import './theme/cssVars.css';

const loadNonCriticalStyles = (): void => {
  const load = (): void => {
    void Promise.all([
      import('react-toastify/dist/ReactToastify.css'),
      import('./styles/global.css'),
    ]);
  };
  if (typeof window === 'undefined') {
    load();
    return;
  }
  window.requestAnimationFrame(() => {
    window.setTimeout(load, 0);
  });
};

loadNonCriticalStyles();

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

const root = ReactDOM.createRoot(rootElement);
const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

const fatalErrors = [...(config.errors ?? [])];
// config.apiBaseUrl always defaults, but if parsing failed we surface errors above.
if (!publishableKey) {
  fatalErrors.push('VITE_CLERK_PUBLISHABLE_KEY is required.');
}

if (fatalErrors.length > 0) {
  root.render(<FatalConfigScreen errors={fatalErrors} />);
} else {
  const safePublishableKey = publishableKey;
  if (!safePublishableKey) {
    throw new Error('VITE_CLERK_PUBLISHABLE_KEY is required.');
  }
  const app = (
    <ThemeModeProvider>
      <AppRoot clerkPublishableKey={safePublishableKey} />
    </ThemeModeProvider>
  );
  root.render(import.meta.env.DEV ? app : <React.StrictMode>{app}</React.StrictMode>);
}
